import { Box, Button, Stack } from '@mui/material';
import { useModal } from '../../hooks/useDialog';
import { SkinnedBalanceModal } from '../../config/skinRegistry/components';
import AddIcon from '@mui/icons-material/Add';
import { useMarketplaceConfig } from '../../queries/marketplace';
import { FormattedBalance } from './FormattedBalance';
import { getWalletModalProps } from '../../config/walletModal';

const styles = {
  walletControls: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#272734',
    padding: { xs: '4px 8px', lg: '4px 4px 4px 16px' },
    gap: '20px',
    borderRadius: '8px',
    cursor: 'pointer',
    height: 'fit-content',
    boxShadow: '0 3px 8px -1px #3232470d, 0 0 1px #0c1a4b3d',
    '&:hover': {
      backgroundColor: '#272734',
      boxShadow: '0 3px 8px -1px #3232470d, 0 0 1px #0c1a4b3d',
    },
  },
  addButtonWrapper: {
    display: { xs: 'none', lg: 'flex' },
    flexGrow: 1,
    backgroundColor: 'primary.main',
    width: 40,
    height: 40,
    padding: '2px',
    borderRadius: '8px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addButton: {
    padding: 0,
    width: 28,
    height: 28,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    display: { xs: 'none', lg: 'flex' },
  },
};

const BalanceButton = () => {
  const { openModal, closeModal } = useModal();
  const { isPay2LocalPayment } = useMarketplaceConfig();

  const handleOpenModal = () => {
    openModal(
      <SkinnedBalanceModal handleClose={closeModal} showBalanceContact={isPay2LocalPayment} />,
      getWalletModalProps({ backgroundColor: 'neutral.700' })
    );
  };

  return (
    <Button onClick={handleOpenModal} sx={styles.walletControls}>
      <Stack
        direction='column'
        sx={{
          alignItems: 'flex-start',
          typography: 'body3',
        }}
      >
        <FormattedBalance balanceType='main' sx={{ color: 'neutral.25' }} />
        {isPay2LocalPayment && <FormattedBalance balanceType='bonus' />}
      </Stack>
      <Box sx={styles.addButtonWrapper}>
        <AddIcon sx={styles.addButton} />
      </Box>
    </Button>
  );
};

export default BalanceButton;
